import { FC } from 'react';

import Page from 'modules/_shared/components/Pages/Page';
import CustomLoading from 'modules/_shared/components/CustomLoading';

import { useEquityMarketAdminPanel } from './context/EquityMarketAdminPanelContext';

import EquityMarketAdminPanelHeader from './components/EquityMarketAdminPanelHeader';
import EquityMarketAdminPanelSummaryCard from './components/EquityMarketAdminPanelSummaryCard';
import EquityMarketAdminPanelOffersList from './components/EquityMarketAdminPanelOffersList';

import '../../styles/Trading.scss';

const EquityMarketAdminPanel: FC = () => {
  const { data, actions } = useEquityMarketAdminPanel();

  return (
    <Page id="equity-market-admin-panel-page">
      <EquityMarketAdminPanelHeader
        societyId={data.societyId}
        societyName={data.societyName}
        equityMarketStatus={data.equityMarketStatus}
        onEquityMarketStatusChange={actions.handleEquityMarketStatusChange}
      />

      <EquityMarketAdminPanelSummaryCard />

      <div className="nk-block">
        <EquityMarketAdminPanelOffersList />
      </div>

      {data.isLoading && <CustomLoading />}
    </Page>
  );
};

export default EquityMarketAdminPanel;
